import { AzureADAppPermissionsModel } from '../../../microsoft/azuread/profile/azure-adapp-permissions-model';
import { ReportProfileResourceBase } from '../../../profile/report-profile-resource-base';
import { ReportProfileRulesComputedDelegate } from '../../../profile/report-profile-rules-computed-delegate';

export class AzureADReportProfile extends ReportProfileResourceBase<ReportProfileRulesComputedDelegate> {
  azureADAppPermissions: AzureADAppPermissionsModel;
}
